import React from "react";
import  './maps.css'
const Map = () => {

  return (
    <>
  
     <iframe
     title="K2 E-Commerce Solutions Location"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.429877402357!2d77.98652657499393!3d30.281821507285855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390929728d040ec1%3A0x7002e4702e0346ea!2sK2%20E-commerce%20Solutions!5e0!3m2!1sen!2sin!4v1698928373528!5m2!1sen!2sin"


  className="map"
  allowfullscreen=""
  loading="lazy"
/>
  <div>
      <h4 style={{color:"#fe4c1c",marginTop:"1rem"}}>Our address</h4>
      <h6>
      -   SR-4 Phase, 1, Transport Nagar, Chandrabani, Dehradun, Sewla
                  Khurd, Uttarakhand 248001
      </h6>
      <h6>
       -   Uttar Pradesh Branch K2 E-Commerce Solutions Mohalla Farashtoli, Town Mandawar, Near Police Station, District Bijnor, Uttar Pradesh – 246721
      </h6>
    </div>
    </>
  );
};

export default Map;
